
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.5 13.5h3.6a.5.5 0 00.48-.36l1.35-4.5 3.1 9.02a.5.5 0 00.47.34.5.5 0 00.47-.33l2.42-6.71 2.14 2.38a.5.5 0 00.82-.12l3.6-7.5a.5.5 0 10-.9-.44l-3.28 6.83-2.2-2.44a.5.5 0 00-.84.16L12.5 16 9.37 6.84a.53.53 0 00-.48-.34.5.5 0 00-.47.36l-1.7 5.64H3.5a.5.5 0 000 1z"}}),_c('path',{attrs:{"d":"M23.5 23H1V.5a.5.5 0 00-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}})])
          )
        }
      }
    